import { Text, SimpleGrid, Container, Button } from "@mantine/core";
import classes from "./FeaturesWhy.module.css";
import { Link } from "react-router-dom";
import WhatisSME from "../../images/What_is_SME.png";
import WhyisSME from "../../images/Why_is_SME.png";
import UnlockBusinessPotential from "../../images/Unlock_Business_Potential.png";
import { useTranslation } from 'react-i18next';

interface FeatureProps extends React.ComponentPropsWithoutRef<"div"> {
  image?: string;
  title?: string;
  description?: string | JSX.Element;
  button?: string;
}

function Feature({
  image,
  title,
  description,
  button,
  className,
  ...others
}: FeatureProps) {
  return (
    <div className={classes.feature} {...others}>
      <div className={classes.overlay} />
      <div className={classes.content}>
        {image && (
          <div>
            <img src={image} alt={title} className={classes.icon} />
          </div>
        )}
        <div>
          {title && <Text className={classes.title}>{title}</Text>}
          {description && (
            <Text className={classes.description}>{description}</Text>
          )}
          {button && (
            <div className={classes.buttonContainer}>
              <Button
                size="sm"
                className={classes.button}
                component={Link}
                to="/contactus"
              >
                {button}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function FeaturesWhy() {
    const { t } = useTranslation();

    const ftwhy = {
        term1: {
          image: WhatisSME,
        },
      
        term2: {
          title: t('home.section3Sub1Title'),
          description: t('home.section3Sub1Description'),
          button: t('common.applyNow'),
        },
      
        term3: {
          title: t('home.section3Sub2Title'),
          description: t('home.section3Sub2Description'),
          button: t('common.applyNow'),
        },
      
        term4: {
          image: WhyisSME,
        },
      
        term5: {
          image: UnlockBusinessPotential,
        },
      
        term6: {
            title: t('home.section3Sub3Title'),
            description: t('home.section3Sub3Description'),
          button: t('common.applyNow'),
        },
      };

      
  const mockdata = ([] = Object.values(ftwhy));
  const items = mockdata.map((item, index) => (
    <Feature {...item} key={index} />
  ));

  return (
    <Container mt={0} mb={0} size="xl" className={classes.featuresContainer}>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 2, lg: 2 }} spacing={10}>
        {items}
      </SimpleGrid>
    </Container>
  );
}
